export interface Action {
	ActionId: number;
	ActionName: string;
	ActionTypeId: number;
}

export interface CacheConfiguration {
	ActionId: number;
	ActionName: string;
	TTLSeconds: number;
	IsActive: boolean;
	Comments: string | null;
	UpdatedBy: string | null;
	UpdatedAt: string | null;
}

export interface QueryCacheConfigurationsResponse {
	configurations: CacheConfiguration[];
	actions: Action[];
}

export interface CacheConfigurationFormValues {
	action: Action | null;
	ttlSeconds: string;
	isActive: boolean;
	comments: string;
}

export const INITIAL_VALUES: CacheConfigurationFormValues = {
	action: null,
	ttlSeconds: "",
	isActive: true,
	comments: "",
};
